import ApiHelper from 'web-app/services/api-helper';
import {Whitelabel} from 'web-app/shared/white-labeling-constants';
import {getWhitelabelUrl} from 'web-app/shared/white-labeling-helpers';

export const extractRouteFromDeepLinkUrl = (url: string, customSchemeProtocol: string) => {
    const whitelabelUrl = getWhitelabelUrl();

    const prefixCandidate = whitelabelUrl ? `https://${whitelabelUrl}` : ApiHelper.environmentUrl;

    const parsedUrl = new URL(url);

    if (parsedUrl.origin.startsWith(prefixCandidate)) {
        return parsedUrl.hash;
    } else if (parsedUrl.protocol === customSchemeProtocol) {
        // The parsed url also interprets the first route segment as the hostname, so prefixing it here.
        // Urls from custom scheme parts are not prefixed with #/ so we need to add it
        return `#/${parsedUrl.hostname}${parsedUrl.pathname}${parsedUrl.search}`;
    } else {
        return null;
    }
};

export const isWebUrl = (url: string) => {
    const parsedUrl = new URL(url);

    return parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';
};

const extractTLD = (url: string) => {
    const parsedUrl = new URL(url);

    return parsedUrl.hostname.split('.').at(-1);
};

export const getDesiredTLD = (whitelabel: Whitelabel | null, url: string) => {
    switch (whitelabel) {
        // As Bright Horizons has their own server setup, we need to use the co.uk TLD for the app.
        case Whitelabel.brighthorizons:
            return 'co.uk';
        // For the Famly app, we respect the TLD of the deep link, as the app can target either AWS or the German servers.
        case null:
            return extractTLD(url);
        // For all other whitelabels, we use the co TLD as there are no whitelabel customers on the German servers.
        default:
            return 'co';
    }
};
